export enum EventSource {
    Unknown = 0,
    FreeWall = 1,
    Microsite = 2
}
